// TSS vite/04 §"Endpoint paths".
// No leading slash — axios joins baseURL + url with a single slash.
//
// RECIBIR, CLASIFICAR Y RESOLVER SON TRES VERBOS Y TRES RUTAS, y eso no es
// ceremonia del backend: es la regla del tier. Clasificar un ticket no es
// editarle un campo `classification` — es una operación con autor y fecha, y
// por eso tiene su propio POST. Lo mismo resolver. Un PATCH genérico sobre el
// ticket habría dejado que cualquiera de las dos pasara sin dejar rastro de
// quién la hizo.
//
// Lo que NO está acá: agrupar tickets en un incidente. Esa relación vive en
// `admin/incidents/{id}/tickets` y es del incidente, no del ticket — un ticket
// no guarda a qué incidente pertenece. Cuando exista la ventana de incidentes,
// sus rutas van en su propio archivo.
export const ticketPaths = {
    list:   ()   => 'admin/tickets',
    detail: (id) => `admin/tickets/${id}`,
    create: ()   => 'admin/tickets',

    classify: (id) => `admin/tickets/${id}/classification`,
    resolve:  (id) => `admin/tickets/${id}/resolution`,
};
